export const ITEMS_PER_PAGE = 20;
export const MAX_VISIBLE_PAGE_BUTTONS = 5;